import axios from 'axios';

const api = axios.create({
  baseURL: 'https://demo.pgf-aspd7a.com', // 替换为你的 API 地址
  timeout: 10000,                     // 超时时间，可选
  headers: { 'Content-Type': 'application/json' }
});

// 设置请求拦截器
api.interceptors.request.use(
  config => {
    // 可在此添加授权 token
    return config;
  },
  error => Promise.reject(error)
);

// 设置响应拦截器
api.interceptors.response.use(
  response => {
      // if(response.data.code == '1003'){
      //     Message.error(utils.setMsg(response.data.msg))
      //     store.commit('SET_GAME_TOKEN', '')
      //     localStorage.removeItem('gameToken')
      // }
      return response
  },
  error => Promise.reject(error)
);

export default api;
